import _defineProperty from "/drone/src/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { forwardRef } from 'react';
import { useComponentTheme } from '../../utils/hooks';
import { useSideSheetClassName } from './utils';
import { sideSheetDefaultTheme } from './theme';
import { Overlay } from '../Overlay';
import { CloseIcon } from '../../icons';
import { SideSheetRoot, SideSheetWindow, SideSheetContent, SideSheetHeaderCloseButtonContainer, SideSheetHeaderCloseButtonContent, SideSheetHeaderContainer } from './style';
import { SIDE_SHEET_CLASS_PREFIX } from './constants';
import { PortalToBody } from '../../system/util/PortalToBody';
import { useSideSheet } from './utils/useSideSheet';
export var SideSheet = forwardRef(function SideSheet(_ref, ref) {
  var className = _ref.className,
      disableOverlay = _ref.disableOverlay,
      wide = _ref.wide,
      props = _objectWithoutProperties(_ref, ["className", "disableOverlay", "wide"]);

  var theme = useComponentTheme(SIDE_SHEET_CLASS_PREFIX, sideSheetDefaultTheme);
  var classOverride = useSideSheetClassName(SIDE_SHEET_CLASS_PREFIX, className, disableOverlay, wide);

  var _useSideSheet = useSideSheet(_objectSpread({
    classOverride: classOverride,
    disableOverlay: disableOverlay,
    wide: wide
  }, props), ref, theme),
      portalProps = _useSideSheet.portalProps,
      rootProps = _useSideSheet.rootProps,
      overlayProps = _useSideSheet.overlayProps,
      windowProps = _useSideSheet.windowProps,
      contentProps = _useSideSheet.contentProps,
      headerContainerProps = _useSideSheet.headerContainerProps,
      closeButtonContainerProps = _useSideSheet.closeButtonContainerProps,
      closeButtonContentProps = _useSideSheet.closeButtonContentProps,
      closeButtonIconProps = _useSideSheet.closeButtonIconProps,
      isCloseButtonVisible = _useSideSheet.isCloseButtonVisible,
      header = _useSideSheet.header,
      body = _useSideSheet.body,
      footer = _useSideSheet.footer;

  return React.createElement(PortalToBody, Object.assign({}, portalProps), React.createElement(SideSheetRoot, Object.assign({}, rootProps, {
    className: classOverride.Root,
    theme: theme
  }), !disableOverlay && React.createElement(Overlay, Object.assign({}, overlayProps, {
    className: classOverride.Overlay,
    theme: theme
  })), React.createElement(SideSheetWindow, Object.assign({}, windowProps, {
    className: classOverride.Window,
    theme: theme
  }), React.createElement(SideSheetContent, Object.assign({}, contentProps, {
    className: classOverride.Content,
    theme: theme
  }), React.createElement(SideSheetHeaderContainer, Object.assign({}, headerContainerProps, {
    className: classOverride.HeaderContainer,
    theme: theme
  }), header, isCloseButtonVisible ? React.createElement(SideSheetHeaderCloseButtonContainer, Object.assign({}, closeButtonContainerProps, {
    className: classOverride.CloseIcon,
    theme: theme
  }), React.createElement(SideSheetHeaderCloseButtonContent, Object.assign({}, closeButtonContentProps, {
    theme: theme
  }), React.createElement(CloseIcon, Object.assign({}, closeButtonIconProps)))) : null), body, footer))));
});
SideSheet.displayName = SIDE_SHEET_CLASS_PREFIX;
SideSheet.defaultProps = {
  disableOverlay: false,
  disableEffects: false,
  disableCloseByEscape: false,
  isCloseButtonVisible: true,
  isFixed: true,
  open: false,
  wide: false
};